import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    logo: {},
    title: {
      fontWeight: 700,
      fontSize: '25px',
      color: theme.colors.common12,
      marginTop: '60px',
      marginBottom: '15px',
      lineHeight: 1.3,
    },
    button: {
      width: '100%',
      height: '32px',
      borderRadius: '3px',
      background: 'rgb(255, 255, 255)',
      color: theme.palette.secondary.main,
      fontSize: '13px',
      fontWeight: 300,
      border: `1px solid ${theme.palette.secondary.main}`,
      cursor: 'pointer',
      outline: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: '12px',
      letterSpacing: 0.75,
      boxShadow: 'none',
    },
  };
};
